import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';

// /authorization — это OIDC redirect_uri. Легально попасть сюда можно только
// в рамках общего цикла авторизации OIDC: провайдер возвращает пользователя
// с параметрами callback (code/state при успехе, error при отказе). Прямой заход
// по URL таких параметров не содержит — заворачиваем на главную, чтобы
// служебная страница-«заглушка» не открывалась сама по себе.
export const authCallbackGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  // SSR не блокируем: маршрут клиентский, окончательное решение — в браузере.
  if (!isPlatformBrowser(inject(PLATFORM_ID))) {
    return true;
  }

  const params = route.queryParamMap;
  const isOidcCallback = params.has('code') || params.has('error');

  return isOidcCallback ? true : inject(Router).parseUrl('/');
};
